import { lazy } from 'react';

import type { RouteConfig } from '../../types';

const DashboardLayout = lazy(() => import('@/layouts/DashboardLayout'));

const NotFoundPage = lazy(() => import('@/pages/NotFoundPage'));

/**
 * `/404` — RouteGuard's redirect target for permission-denied paths (and a
 * routable page in its own right). Rendered inside the shell so the user
 * keeps the sidebar. It matches no `routeAccess` rule, so it is never denied.
 *
 * There is no `/` route: the AppRouter catch-all forwards `/` (and every
 * unknown path) to the landing page (`LandingRedirect`).
 */
export const notFoundRoutes: RouteConfig = {
  path: '/404',
  layout: DashboardLayout,
  element: NotFoundPage,
};
